import styled from "styled-components";
import {colors} from "../../../themes/colors";
import {sizes} from "../../../themes/sizes";
import {fontSize} from "../../../themes/css";

export const CalendarInput = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
  padding: 8px 24px 8px 8px;
  background: ${colors.general.white};
  border: 1px solid ${props => props.error ? colors.border.burntSienna : colors.border.silver};
  border-radius: 4px;
  cursor:  ${props => props.disabled ? 'not-allowed' : 'pointer'};
  font-style: normal;
  font-weight: 700;
  ${fontSize(14)}
  line-height: 140%;
  color: ${props => props.empty ? colors.text.gray : colors.text.ebony};
  opacity: ${props => props.disabled ? 0.6 : 1};
  @media only screen and ${sizes.max991} {
    padding: 1.6vw 4.8vw 1.6vw 1.6vw;
  }
`;

export const CalendarIcon = styled.img`
  width: 24px;
  @media only screen and ${sizes.max991} {
    width: 4.8vw;
  }
`;

export const PickerWrapper = styled.div`
  //  tr {
  //  border-top: solid 5px #ffffff;
  //}
  .CalendarDay__selected {
    background: ${colors.background.kleinBlue};
    color: #ffffff !important;
  }
  .CalendarDay__selected_span {
    background: ${colors.background.danube};
    color: #ffffff !important;
  }
  .CalendarDay__default {
    color: black;
    font-weight: 700;
  }
  .CalendarDay__blocked_out_of_range {
    color: #828282 !important;
  }
  //.CalendarMonth_table {
  //  margin-top: 13px;
  //}
  //.DateInput_input__focused {
  //  border-bottom: none;
  //}
  //.DateRangePicker {
  //  width: 100%;
  //}
  //.DateRangePicker_picker {
  //  top: 70px !important;
  //  left: 0 !important;
  //}
  //.DateRangePickerInput {
  //  display: flex;
  //}

  //.dates-wrapper {
  //  display: flex;
  //  flex-direction: row;
  //  @media only screen and (max-width: 991px) {
  //    width: 100%;
  //  }
  //}
  //.DayPickerNavigation {
  //  display: flex;
  //  top: 22px;
  //  justify-content: space-between;
  //}
  //.CalendarMonth_caption {
  //  font-size: 14px;
  //}
  .DayPicker_weekHeader {
    color: #828282;
    ${fontSize(13)}
    text-transform: uppercase;
  }
  .CalendarDay__selected {
    border-color: ${colors.background.danube};;
  }
  .CalendarDay__selected_span {
    background: ${colors.background.danube};
    border-color: ${colors.background.danube};;
  }
  .CalendarDay__hovered_span {
    background: ${colors.background.danube};
    border-color: ${colors.background.danube};
    color: white;
  }
`;
